const API_URL = 'https://api.spotify.com/v1';

const TOKEN_API = 'BQC92Fs_NtWgMSxK61-Gx3o3BO0dznc15wUgsL2_dy-TiwgkGD7ezNB0vs6JBxwjhm-ewmaLIprmvMqvKM8DL257zT7JdN-jd6Wb39JrNR_hmj5MYMphjUbVx9PV9tLs8sP8N9AU7oDATRVBK6o';

const HEADERS = {
  headers: {
    Authorization: `Bearer ${TOKEN_API}`,
  },
};

export { API_URL, HEADERS };



// WEBPACK FOOTER //
// ./src/config.js